import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useBooking } from "@/contexts/BookingContext"

interface Props {
  bookingUrl: string
}

export function BookingPopup({ bookingUrl }: Props) {
  const { isOpen, close } = useBooking()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && close()}>
      <DialogContent className="max-w-3xl p-0 gap-0 overflow-hidden sm:max-w-3xl">
        <DialogHeader className="px-6 pt-6 pb-4">
          <DialogTitle className="font-heading text-xl">
            Varaa keskusteluaika
          </DialogTitle>
        </DialogHeader>
        {bookingUrl ? (
          <iframe
            src={bookingUrl}
            className="w-full h-[640px] border-0"
            title="Varaa keskusteluaika"
            loading="lazy"
          />
        ) : (
          <div className="p-8 text-center text-muted-foreground">
            Varauskalenteria ei ole vielä konfiguroitu.
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
